export default __webpack_public_path__ + "static/media/desktopScreen.7d84b670.png";